import React from 'react';
import styled, { keyframes } from 'styled-components';

const walkCycleSteve = keyframes`
  from { background-position: 0px 0; }
  to { background-position: -192px 0; }
`;

const walkCycleMario = keyframes`
  from { background-position: 0px 0; }
  to { background-position: -288px 0; }
`;

const walkCycleGhost = keyframes`
  from { background-position: 0px 0; }
  to { background-position: -96px 0; }
`;

const runAcrossLoop = keyframes`
  0% {
    left: -310px;
  }
  100% {
    left: 100vw;
  }
`;

const RunnerGroup = styled.div`
  position: fixed;
  bottom: 0px;
  left: -310px;
  width: 304px;
  height: 48px;
  z-index: 2147483640;
  pointer-events: none;
  animation: ${runAcrossLoop} 12s linear infinite;
`;

const SteveSprite = styled.div`
  position: absolute;
  left: 256px;
  top: 0;
  width: 48px;
  height: 48px;
  background-image: url('${process.env.PUBLIC_URL || ''}/steve-walk.png');
  background-size: 192px 48px;
  background-repeat: no-repeat;
  image-rendering: pixelated;
  animation: ${walkCycleSteve} 0.6s steps(4) infinite;
`;

const MarioSprite = styled.div`
  position: absolute;
  left: 194px;
  top: 0;
  width: 48px;
  height: 48px;
  background-image: url('${process.env.PUBLIC_URL || ''}/mario-walk.png');
  background-size: 288px 48px;
  background-repeat: no-repeat;
  image-rendering: pixelated;
  animation: ${walkCycleMario} 0.8s steps(6) infinite;
`;

const PinkySprite = styled.div`
  position: absolute;
  left: 66px;
  top: 0;
  width: 48px;
  height: 48px;
  background-image: url('${process.env.PUBLIC_URL || ''}/pinky-walk.png');
  background-size: 96px 48px;
  background-repeat: no-repeat;
  image-rendering: pixelated;
  animation: ${walkCycleGhost} 0.3s steps(2) infinite;
`;

const InkySprite = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  background-image: url('${process.env.PUBLIC_URL || ''}/inky-walk.png');
  background-size: 96px 48px;
  background-repeat: no-repeat;
  image-rendering: pixelated;
  animation: ${walkCycleGhost} 0.3s steps(2) infinite;
`;

export default function SteveRunner() {
  return (
    <RunnerGroup>
      <InkySprite />
      <PinkySprite />
      <MarioSprite />
      <SteveSprite />
    </RunnerGroup>
  );
}
